'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _LinkContainer = require('./LinkContainer');

var _LinkContainer2 = _interopRequireDefault(_LinkContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Don't use a stateless function, to allow users to set a ref.
/* eslint-disable react/prefer-stateless-function */
var IndexLinkContainer = function (_React$Component) {
  _inherits(IndexLinkContainer, _React$Component);

  function IndexLinkContainer() {
    _classCallCheck(this, IndexLinkContainer);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  IndexLinkContainer.prototype.render = function render() {
    return _react2.default.createElement(_LinkContainer2.default, _extends({}, this.props, { exact: true }));
  };

  return IndexLinkContainer;
}(_react2.default.Component);
/* eslint-enable react/prefer-stateless-function */


exports.default = IndexLinkContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-router-bootstrap/lib/IndexLinkContainer.js
// module id = 1577
// module chunks = 0